<template>
  <v-container fluid>
    <v-card>
      <v-card-title>Pendências</v-card-title>
      <v-card-text v-if="validacoes.length > 0">
        <v-alert v-for="v in validacoes" :key="v" color="error" dark>
          {{ v }}
        </v-alert>
      </v-card-text>
      <v-card-text v-else>
        <v-alert color="accent"> Não há pendências </v-alert>
      </v-card-text>
      <v-card-actions>
        <v-toolbar elevation="0">
          <v-btn color="warning" @click="voltar"> Voltar </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            :disabled="validacoes.length > 0 || carregando"
            @click="dialog = !dialog"
          >
            <v-progress-circular
              v-if="carregando"
              indeterminate
              color="white"
            ></v-progress-circular>
            Finalizar e Enviar a Documentação
          </v-btn>
        </v-toolbar>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="dialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Confirmação</v-card-title>
        <v-card-text
          >Tem certeza que deseja finalizar o preenchimento da Pre Matrícula?
          Não será mais possível alterar os dados após essa ação</v-card-text
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="warning" text @click="cancelarFinalizacao"
            >Voltar</v-btn
          >
          <v-btn color="success" text @click="finalizar">Finalizar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>


<script>
import * as PreMatriculaService from "@/services/prematricula.service";

export default {
  props: {
    validacoes: {
      type: Array,
      required: true,
    },
    carregando: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      emProcessando: true,
    };
  },
  mounted() {},
  methods: {
    voltar() {
      this.$emit("voltar");
    },
    cancelarFinalizacao() {
      this.dialog = false;
    },
    finalizar() {
      this.emProcessando = true;
      this.$nprogress.start();
      PreMatriculaService.finalizar()
        .then(() => {
          this.$msg.success("Prematricula Finalizada");
          this.$router.push({ name: "acompanhamento" });
        })
        .finally(() => {
          this.$nprogress.done();
          this.emProcessando = true;
        });
    },
  },
};
</script>